import { TFunction } from 'react-i18next';
import { ISelectorOption } from 'types/ISelectorOption';
import { videoType } from 'types/Posts';

export const videoSpecOptions = (translate: TFunction<'translation'>) => {
  const videoTypeOptions: ISelectorOption<videoType>[] = [
    {
      label: translate('addVideoDashboard.videoSpecs.videoType.withDrone'),
      value: 'WITHDRONE',
    },
    { label: translate('addVideoDashboard.videoSpecs.videoType.withPpov'), value: 'WITHPOV' },
    {
      label: translate('addVideoDashboard.videoSpecs.videoType.droneRacing'),
      value: 'DRONERACING',
    },
    {
      label: translate('addVideoDashboard.videoSpecs.videoType.stabilizer'),
      value: 'STABILIZER',
    },
    { label: translate('addVideoDashboard.videoSpecs.videoType.macro'), value: 'MACRO' },
  ];

  return { videoTypeOptions };
};
